import React from 'react';
import { CheckCircle, Car } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AirportPickup: React.FC = () => {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate('/eligibility?service=travel');
    };

    return (
        <div className="bg-white min-h-screen pt-32 pb-20">
            <div className="bg-[#009B8F] text-white py-16 mb-16">
                <div className="max-w-7xl mx-auto px-6">
                    <h1 className="text-4xl md:text-5xl font-serif mb-4">Airport Pickup & Drop-off Coordination</h1>
                    <p className="text-xl text-white/90 max-w-2xl">
                        Smooth, secure, and stress-free airport transfers.
                    </p>
                </div>
            </div>

            <div className="max-w-5xl mx-auto px-6">
                <div className="flex items-center gap-4 mb-8">
                    <div className="p-3 bg-[#009B8F]/10 rounded-full">
                        <Car className="text-[#009B8F] w-8 h-8" />
                    </div>
                    <h2 className="text-3xl font-serif text-[#011E26]">Your First Step in a New Country</h2>
                </div>

                <div className="bg-amber-50 border-l-4 border-amber-500 p-4 mb-8">
                    <p className="text-amber-800 text-sm font-medium">
                        <strong>Note:</strong> NexOverseas is currently under construction and operating exclusively in the UK.
                    </p>
                </div>

                <div className="prose prose-lg text-slate-600 max-w-none">
                    <p className="mb-4">
                        Our Airport Pickup & Drop-off Coordination service ensures your journey from the airport to your new home or temporary accommodation is smooth, secure, and stress-free.
                    </p>
                    <p className="mb-4">
                        We partner with trusted transport providers to guarantee punctual arrivals and comfortable rides.
                    </p>

                    <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#009B8F] mb-8">
                        <h3 className="text-lg font-bold text-[#011E26] mb-3 uppercase tracking-wide">By booking through NexOverseas, you benefit from:</h3>
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {[
                                "Exclusive discounts on airport transfers",
                                "Dedicated support for any travel issues",
                                "Guidance on local transportation options",
                                "Safe and well-organized arrivals"
                            ].map((item, i) => (
                                <li key={i} className="flex items-start gap-2 text-sm font-medium">
                                    <CheckCircle className="w-5 h-5 text-[#009B8F] flex-shrink-0" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <p className="mb-6">
                        Your first step in a new country is safe and well-organized with NexOverseas.
                    </p>

                    <button
                        onClick={handleContactClick}
                        className="bg-[#009B8F] text-white px-8 py-3 font-bold uppercase tracking-widest hover:bg-[#00857a] transition-colors rounded-sm shadow-lg"
                    >
                        Get in Touch
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AirportPickup;
